<template>
  <v-dialog
    v-if="selected"
    :value="dialog"
    :hide-overlay="!dialog"
    @click:outside.stop="closeDialog(true)"
    @keydown.esc="closeDialog(true)"
    persistent
    max-width="599px"
    :fullscreen="is_mobile"
    :scrollable="is_mobile"
    overlay-opacity="50"
    overlay-color="#ffffff"
    content-class="default-dialog"
    >
    <v-card class="default-dialog-card">
      <v-card-title>
        <span class="headline">
          <v-icon class="toolbar-icon" v-text="getTitle_.icon"/>
          {{ getTitle_.title }}
        </span>
        <v-spacer></v-spacer>
        <v-icon class="dialog-close-btn" @click="closeDialog(true)">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="px-0">
        <v-container
          v-bar="{ preventParentScroll: true, scrollThrottle: 30, resizeRefresh: true }"
          class="overflow-y-auto dialog-scrollbar"
          style="max-height: 400px; padding: 9px 0px !important;"
        >
          <v-form
            ref="SaveForm"
            v-model="valid"
            lazy-validation
            :disabled="get_interface.loading"
          >
            <v-row class="px-3 py-2">
              <v-col cols="12" lg="5" md="12" sm="12" class="pa-1 mh-70">
                <v-text-field
                  v-model="selected.title"
                  :label="lang.financial.cashflow.new.form.title"
                  :rules="lang.financial.cashflow.new.form.rules.title"
                  :loading="get_interface.loading"
                  :disabled="get_interface.loading"
                  autocomplete="new-password"
                  filled
                />
              </v-col>
              <v-col cols="12" lg="4" md="12" sm="12" class="pa-1 mh-70">
                <DatetimePicker
                  :label="lang.financial.cashflow.new.form.date"
                  v-model="selected.datetime"
                />
              </v-col>
              <v-col cols="12" lg="3" md="12" sm="12" class="pa-1 mh-70">
                <v-currency-field
                  v-model="selected.value"
                  :label="lang.financial.cashflow.new.form.value"
                  :rules="lang.financial.cashflow.new.form.rules.value"
                  :loading="get_interface.loading"
                  disabled
                  filled
                />
              </v-col>
            </v-row>
            <v-row class="px-3 py-2">
              <v-col cols="12" class="pa-1">
                <Widget
                  v-model="selected.meta"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="gray" text @click="closeDialog(true)">{{ lang.items.view.close }}</v-btn>
        <v-btn
          color="green darken-1"
          text
          @click="save_(selected)"
          :loading="get_interface.loading"
          :disabled="get_interface.loading"
        >
          {{ lang.items.actions.save }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Widget from './templates/widget/Widget'
import DatetimePicker from '@/components/utils/DatetimePicker'

import appdata from '@/mixins/appdata'
import save from '@/mixins/defaults/save'
import utils from '@/mixins/utils'
import bills from './mixins/index'

export default {
  components: { Widget, DatetimePicker },
  mixins: [ appdata, save, utils, bills ],
  data () {
    return {
      valid: false
    }
  },
  computed: {
    getTitle_ () {
      let action = (this.id < 1 ? 'new' : 'edit'),
          title_s = this.lang.financial.bills.title_s
      return {
        icon: `mdi-file-document${(this.id > 0 ? '-edit' : '')}`,
        title: `${this.lang.financial.bills.actions[action]} ${title_s}${(this.id > 0 ? ' #' + this.id : '')}`,
        title_s
      }
    }
  },
  watch: {
    'selected.meta': {
      deep: true,
      handler (newVal) {
        this.selected.value = newVal.reduce((acc, curr) => parseFloat((acc + parseFloat(curr[3])).toFixed(10)), 0)
      }
    }
  }
}
</script>
